<template>
    <Head title="ActivityLog" />
    <div class="card card-outline card-primary">
        <div class="card-header">
            <h3 class="card-title">ACTIVITY LOG</h3>
            <div class="card-tools">
                <Link href="/home" class="btn btn-tool"><i class="fas fa-times"></i></Link>
            </div>
        </div>
        <div class="card-body table-responsive">
            <data-table :columns="columns" :ajax="{ url: '/datatables/clientlog' }" 
                :order="[2, 'desc']"></data-table>
        </div>
    </div>
</template>
  
<script>
import Layout from '@/Layouts/Master'
import { Head, Link } from '@inertiajs/vue3'
import DataTable from '@/Forms/DataTable'

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        DataTable,
    },
    data() {
        return {
            columns: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Diskripsi', data: 'description' },
                { title: 'Waktu', data: 'created_at' }
            ],
        }
    },
}
</script>